import { useIsFocused, useNavigation } from '@react-navigation/native'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CSStackContext } from '../CSStackContext'
import { AppContext, Permission, TabView, TabViewInfo } from '@pulseops/common'
import { View } from 'react-native'
import { OPLSharedStyles } from '../../opl/opl-common'
import { CSInventoryReportCreatingDoc } from './CSInventoryReportCreatingDoc'
import { CSInventoryReportDocList } from './CSInventoryReportDocList'
export const CSInventoryReportDoc = () => {
  const { t } = useTranslation()
  const isFocused = useIsFocused()
  const rootNavigation = useNavigation()
  const [isActiveTabIndex, setIsActiveTabIndex] = React.useState(0)
  const { userPermissions } = React.useContext(CSStackContext)
  const { changeBreadcrumb } = React.useContext(AppContext.AppContextInstance)
  const getTabList = () => {
    const tabList: TabViewInfo[] = []
    if (userPermissions.includes(Permission.ViewInventoryReportList)) {
      tabList.push({
        tabName: t('OPL_CS:CS:List'),
        tabKey: 0
      })
    }
    if (userPermissions.includes(Permission.ViewUploadInventoryReport)) {
      tabList.push({
        tabName: t('OPL_CS:CS:UploadDocument'),
        tabKey: 1
      })
    }
    return tabList
  }

  React.useEffect(() => {
    if (isFocused) {
      changeBreadcrumb([
        {
          title: '',
          navigate: () => {
            rootNavigation.navigate('HomeScreen')
          }
        },
        {
          title: t('menu:DocumentManagement'),
          navigate: () => rootNavigation.navigate('CSScreen')
        },
        {
          title: t('OPL_CS:CS:InventoryReport'),
          navigate: null
        }
      ])
    }
  }, [isFocused])

  const getComponentByTabIndex = () => {
    switch (isActiveTabIndex) {
      case 0:
        return userPermissions.includes(Permission.ViewInventoryReportList) ? (
          <CSInventoryReportDocList></CSInventoryReportDocList>
        ) : (
          <></>
        )
      case 1:
        return userPermissions.includes(Permission.ViewUploadInventoryReport) ? (
          <CSInventoryReportCreatingDoc setIsActiveTabIndex={setIsActiveTabIndex}></CSInventoryReportCreatingDoc>
        ) : (
          <></>
        )
      default:
        return <></>
    }
  }

  return (
    <View style={OPLSharedStyles.wrapper}>
      <TabView
        isActiveTabIndex={isActiveTabIndex}
        setIsActiveTabIndex={setIsActiveTabIndex}
        data={getTabList()}
      ></TabView>
      {getComponentByTabIndex()}
    </View>
  )
}
